// Consentement explicite (art. 9.2.a RGPD) : un écran en clair, une case non
// pré-cochée, un bouton « J'accepte ». Rien n'est enregistré avant.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Bouton, Erreur, SousTitre, Texte, Titre } from '../components/base';
import { api } from '../lib/api';
import { CLES } from '../lib/requetes';

export function Consentement({
  role,
  version,
}: Readonly<{ role: 'elle' | 'proche'; version: string }>) {
  const { t } = useTranslation();
  const client = useQueryClient();
  const [coche, setCoche] = useState(false);
  const accepter = useMutation({
    mutationFn: () => api.consentir(version),
    onSuccess: () => client.invalidateQueries({ queryKey: CLES.moi }),
  });
  const points = t(`consentement.${role}.points`, { returnObjects: true }) as string[];

  return (
    <section>
      <Titre>{t('consentement.titre')}</Titre>
      <Texte>{t(`consentement.${role}.intro`)}</Texte>
      <SousTitre>{t('consentement.ceQuiEstGarde')}</SousTitre>
      <ul className="text-texte-long mt-3 list-disc space-y-2 pl-5 leading-relaxed">
        {points.map((p) => (
          <li key={p}>{p}</li>
        ))}
      </ul>
      <Texte>
        {t('consentement.plus')}{' '}
        <Link to="/confidentialite" className="text-accent underline underline-offset-4">
          {t('pied.confidentialite')}
        </Link>
        .
      </Texte>
      <label className="mt-8 flex items-start gap-3">
        <input
          type="checkbox"
          checked={coche}
          onChange={(e) => setCoche(e.target.checked)}
          className="accent-accent mt-1 size-5 shrink-0"
        />
        <span>{t(`consentement.${role}.case`)}</span>
      </label>
      <Bouton
        className="mt-6"
        disabled={!coche || accepter.isPending}
        onClick={() => accepter.mutate()}
      >
        {t('consentement.accepter')}
      </Bouton>
      {accepter.isError && <Erreur>{t('erreur.action')}</Erreur>}
    </section>
  );
}
